import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MessageModal from 'components/modal/MessageModal';
import withLoadingScreen from 'hoc/withLoadingScreen';
import PageDoesNotExist from 'pages/PageDoesNotExist';
import OverviewPage from 'pages/overviewPage/OverviewPage';
import BookingDetailsPage from 'pages/bookingsDetailsPage/BookingsDetailsPage';
import BookingsListPage from 'pages/bookingsListPage/BookingsListPage';
import PaymentStatusPage from 'pages/PaymentStatusPage';
import PaymentStatusPageNoSession from 'pages/PaymentStatusPageNoSession';
import PaymentForm from 'pages/bookingsDetailsPage/paymentsTab/paymentForm';
import DocumentPage from 'pages/documentPage/DocumentPage';
import Login from 'pages/login/Login';
import SSOLoginSuccess from 'pages/login/SSOLoginSuccess';
import SSOLoginFail from 'pages/login/SSOLoginFail';
import ProfilePage from 'pages/profilePage/ProfilePage';
import QuotesDetailsPage from 'pages/quotesDetailsPage/QuotesDetailsPage';
import QuotesListPage from 'pages/quotesListPage/QuotesListPage';
import Spinner from 'components/Spinner';
import { toggleFeedbackBar } from 'reducers/ui/uiSlice';
import { ROUTES_SELF_SERVICE } from './shared/constants/selfServiceRoutes';

function SelfServiceApp() {
  const dispatch = useDispatch();
  const { showAppOverlay, showLoadingAppOverlay, showFeedbackBar, feedbackBarDetails, componentConfig } = useSelector(
    (state) => state.ui,
  );

  return (
    <Router>
      <div>
        {(showAppOverlay || showLoadingAppOverlay) && (
          <div className={`h-screen w-screen fixed z-[2] ${
            showLoadingAppOverlay
              ? 'bg-white flex items-center justify-center'
              : 'bg-black/[.5]'
            }`}
          >
            {showLoadingAppOverlay && <Spinner />}
          </div>
        )}
        <MessageModal
          showModal={showFeedbackBar}
          message={feedbackBarDetails?.message}
          error={feedbackBarDetails?.error}
          openModalHandler={() => dispatch(toggleFeedbackBar(false))}
        />
        <Routes>
          <Route
            path="/"
            element={componentConfig?.multiBookingEnabled ? <OverviewPage /> : <BookingDetailsPage />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.OVERVIEW}
            element={<OverviewPage />}
          />
          <Route
            path={`${ROUTES_SELF_SERVICE.BOOKINGS}/:bookingId`}
            element={<BookingDetailsPage />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.BOOKINGS}
            element={<BookingsListPage />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.QUOTES}
            element={<QuotesListPage />}
          />
          <Route
            path={`${ROUTES_SELF_SERVICE.QUOTES}/:quoteId`}
            element={<QuotesDetailsPage />}
          />
          <Route path={ROUTES_SELF_SERVICE.PROFILE} element={<ProfilePage />} />
          <Route
            path={ROUTES_SELF_SERVICE.DOCUMENTS}
            element={<DocumentPage />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.PAYMENTFORM}
            element={<PaymentForm />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.PAYMENTSTATUS}
            element={<PaymentStatusPage />}
          />
          <Route
            path={ROUTES_SELF_SERVICE.PAYMENTSTATUSNOSESSION}
            element={<PaymentStatusPageNoSession />}
          />
          <Route path={ROUTES_SELF_SERVICE.LOGIN} exact element={<Login />} />
          <Route path={ROUTES_SELF_SERVICE.SSOLOGINSUCCESS} element={<SSOLoginSuccess />} />
          <Route path={ROUTES_SELF_SERVICE.SSOLOGINFAIL} element={<SSOLoginFail />} />
          <Route path="*" element={<PageDoesNotExist />} />
        </Routes>
      </div>
    </Router>
  );
}

export default withLoadingScreen(SelfServiceApp);
